import styled from "styled-components";

export const Container = styled.div`
@media (max-width: 1023px) {
  display: none;
}
`